"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toGlobalId = toGlobalId;
exports.fromGlobalId = fromGlobalId;
/*
 * Copyright (c) "Neo4j"
 * Neo4j Sweden AB [http://neo4j.com]
 *
 * This file is part of Neo4j.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const graphql_1 = require("graphql");
const base64_1 = require("graphql-relay/utils/base64");
function toGlobalId({ typeName, field, id }) {
    return (0, base64_1.base64)([typeName, field, graphql_1.GraphQLID.serialize(id)].join(":"));
}
function fromGlobalId(id, isInt) {
    const unbasedGlobalId = (0, base64_1.unbase64)(id);
    const [typeName, field, ...rest] = unbasedGlobalId.split(":");
    return {
        typeName,
        field,
        id: isInt ? parseInt(rest[0], 10) : rest.join(":"),
    };
}
//# sourceMappingURL=global-ids.js.map